import { Controller } from "@hotwired/stimulus"

const DAY = 86400000

// Narrows the past-stay calendar to the chosen stay: nights before it began or after it
// ended, and nights the neighbor already held a bed, are greyed out here instead of the
// server refusing the range. Each option carries its stay's first and last night and the
// neighbor's held ranges; the sheet's own bounds and held nights come back when nothing
// is chosen.
export default class extends Controller<HTMLElement> {
  static targets = ["stay"]
  static values = { minimum: String, maximum: String, disabled: Array }
  declare readonly stayTarget: HTMLSelectElement
  declare readonly minimumValue: string
  declare readonly maximumValue: string
  declare readonly disabledValue: string[]

  connect() { this.narrow() }

  narrow() {
    const calendar = this.element.querySelector<HTMLElement>("[data-controller~='date-range-calendar']")
    if (!calendar) return
    const stay = this.stayTarget.selectedOptions[0]?.dataset ?? {}
    calendar.dataset.dateRangeCalendarMinimumValue = latest(this.minimumValue, stay.start)
    calendar.dataset.dateRangeCalendarMaximumValue = earliest(this.maximumValue, stay.end)
    calendar.dataset.dateRangeCalendarDisabledValue = JSON.stringify([...this.disabledValue, ...this.heldNights(stay.held)])
  }

  // Held ranges are [first, last] nights, last null while the bed is still held; only the
  // nights the sheet can show are expanded.
  private heldNights(ranges = "[]") {
    return (JSON.parse(ranges) as [string, string | null][]).flatMap(([first, last]) => {
      const nights: string[] = []
      const end = Date.parse(earliest(last ?? undefined, this.maximumValue))
      for (let time = Date.parse(latest(first, this.minimumValue)); time <= end; time += DAY) {
        nights.push(new Date(time).toISOString().slice(0, 10))
      }
      return nights
    })
  }
}

// ISO dates order as strings.
const latest = (...dates: (string | undefined)[]) => dates.filter(Boolean).sort().at(-1) ?? ""
const earliest = (...dates: (string | undefined)[]) => dates.filter(Boolean).sort()[0] ?? ""
